export default {
  // NOTE: 分析レポート > TAC.Tポイント > 利用時間
  work_time: [
    {
      key: 'private',
      label: '一人ワーク',
      backgroundColor: '#55a765',
      data: [ 22, 0, 18, 10, 3 ],
    },
    {
      key: 'group',
      label: '複数人ワーク',
      backgroundColor: '#d16b15',
      data: [ 20, 35, 43, 12, 23 ],
    },
  ],
  // NOTE:お知らせ
  notices: [
    {
      icon: 'ion-md-person',
      title: 'イベント運営',
      description: '本日15:00- カフェテリアにて、AI勉強会を実施します。今回は外部講師の○○さんをお呼び・・',
      time: '2019-08-20',
    },
    {
      icon: 'icon-ai',
      title: 'TAC.T ボット',
      description: 'リフレッシュのため自席から少し離れてみてはどうですか？',
      time: '2019-08-19',
    },
    {
      icon: 'ion-md-person',
      title: '施設運営',
      description: '14:00- カフェテリアにてもぐもぐタイム実施中！本日のお菓子はルマンドです。',
      time: '2019-08-18',
    },
    {
      icon: 'ion-md-person',
      title: '田中一郎',
      description: '17:30- 野外でPythonもくもく会を実施します。',
      time: '2019-07-20',
    },
    {
      icon: 'icon-ai',
      title: 'TAC.T ボット',
      description: '今日は外が涼しいので読書にいいですよ。',
      time: '2019-07-19',
    },
    {
      icon: 'ion-md-person',
      title: '施設運営',
      description: '14:00- カフェテリアにてもぐもぐタイム実施中！本日のお菓子は生八ツ橋です。',
      time: '2018-12-18',
    },
  ],
  // NOTE:検索履歴
};



// WEBPACK FOOTER //
// ./src/stub.js